import { inject, Injectable, signal, WritableSignal } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { environment } from '../../../environments/environment';
import { TurnoAsignado } from '../../models/Turno.model';
import { Sala } from '../../models/Sala.model';
import { CredentialsService } from '../local/credentials.service';

const { apiUrl } = environment;

type FilaSignal = {
  fila: TurnoAsignado[];
  close: () => void;
}

@Injectable({
  providedIn: 'root'
})
export class SalaService {
  private httpClient = inject(HttpClient);
  private credentialsService = inject(CredentialsService);

  getTurnosDeSala(salaId: string): WritableSignal<FilaSignal> {
    const filaSignal: WritableSignal<FilaSignal> = signal({ fila: [], close: () => {} });
    let eventSource: EventSource;
    let reconnectTimeout: number | null = null;
    let isManuallyClosed = false;

    const connect = () => {
      eventSource = new EventSource(`${apiUrl}/salas/${salaId}/turnos-asignados-sse`);
      
      eventSource.onmessage = (event) => {
        filaSignal.set({
          fila: JSON.parse(event.data),
          close: () => {
            isManuallyClosed = true;
            if (reconnectTimeout) {
              clearTimeout(reconnectTimeout);
              reconnectTimeout = null;
            }
            eventSource.close();
          }
        });
      };

      eventSource.onerror = (error) => {
        console.error('EventSource connection error:', error);
        eventSource.close();
        
        // Only attempt to reconnect if not manually closed
        if (!isManuallyClosed) {
          reconnectTimeout = window.setTimeout(() => {
            console.log('Attempting to reconnect EventSource...');
            connect();
          }, 10000); // 10 seconds
        }
      };
    };

    connect();

    return filaSignal;
  }

  getSalas(sucursalId: number) {
    const credentials = this.credentialsService.credentials();
    return this.httpClient.get<Sala[]>(`${apiUrl}/salas?sucursalId=${sucursalId}`, {
      headers: {
        'Authorization': `Basic ${credentials}`
      }
    });
  }
  
}
